// extracted by mini-css-extract-plugin
module.exports = {"statisticscGridItem":"statistics_statisticscGridItem__ttOUa"};